import { useMutation } from 'react-query';

import {
  RenderWhatsappTemplateParamsDto,
  RenderedWhatsappTemplateParamsDto,
} from '@bandido/shared/dtos';
import { client } from '@frontend/features/common/services';

type RenderTemplateParamsPayload = {
  templateId: string;
  data: RenderWhatsappTemplateParamsDto;
};

export const useRenderTemplateParams = (agencyId?: number) =>
  useMutation(
    async ({
      templateId,
      data,
    }: RenderTemplateParamsPayload): Promise<RenderedWhatsappTemplateParamsDto> => {
      if (!agencyId) {
        return Promise.reject(new Error('Agency ID is required'));
      }

      const response = await client.post(
        `/whatsapp/templates/${agencyId}/${templateId}/render`,
        data,
      );

      return response.data;
    },
  );
